import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SicotService } from '../sicot.service';
import { CotAdminUser } from '../types/CotAdminUser';
import { TipoSegnalazioneAdmin } from '../types/TipoSegnalazioneAdmin';
import { CommonModule } from '@angular/common';

export interface CollegaTipoSegnalazioneDialogData {
  user: CotAdminUser;
}

@Component({
  selector: 'app-collega-tipo-segnalazione-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './collega-tipo-segnalazione-dialog.component.html',
  styleUrl: './collega-tipo-segnalazione-dialog.component.css',
})
export class CollegaTipoSegnalazioneDialogComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<CollegaTipoSegnalazioneDialogComponent>);
  private readonly data = inject<CollegaTipoSegnalazioneDialogData>(MAT_DIALOG_DATA);
  private readonly sicot = inject(SicotService);

  user: CotAdminUser = this.data.user;
  allTipi: TipoSegnalazioneAdmin[] = [];
  selectedIds: Set<number> = new Set();
  loading = true;
  saving = false;
  errorMessage: string | null = null;

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.errorMessage = null;
    this.sicot.getTipiSegnalazioneAdmin().subscribe({
      next: (list) => {
        this.allTipi = list ?? [];
        this.sicot.getUserTipiSegnalazione(this.user.id).subscribe({
          next: (userTipi) => {
            this.selectedIds = new Set((userTipi ?? []).map((t) => t.id));
            this.loading = false;
          },
          error: () => {
            this.selectedIds = new Set();
            this.loading = false;
          },
        });
      },
      error: () => {
        this.loading = false;
        this.errorMessage = 'Errore nel caricamento dei tipi segnalazione';
      },
    });
  }

  isSelected(t: TipoSegnalazioneAdmin): boolean {
    return this.selectedIds.has(t.id);
  }

  toggle(t: TipoSegnalazioneAdmin): void {
    if (this.selectedIds.has(t.id)) {
      this.selectedIds.delete(t.id);
    } else {
      this.selectedIds.add(t.id);
    }
    this.selectedIds = new Set(this.selectedIds);
  }

  save(): void {
    this.saving = true;
    this.errorMessage = null;
    this.sicot.setUserTipiSegnalazione(this.user.id, Array.from(this.selectedIds)).subscribe({
      next: () => this.dialogRef.close(true),
      error: (err) => {
        this.saving = false;
        this.errorMessage = err?.error?.message ?? err?.message ?? 'Errore nel salvataggio';
      },
    });
  }
}
